import React from 'react';
import {Button, ControlLabel, FormControl, FormGroup, Modal} from 'react-bootstrap';
import Table from '../../../../../../components/Table';
import './styles.css'
import _ from "lodash";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {personFullName} from "../../../../../../services/Api";
import SelectAsync from 'react-select/lib/Async';

class CertificateDetailModal extends React.Component {
    static contextTypes = {api: PropTypes.object, notifier: PropTypes.object};

    constructor(props) {
        super(props);
        this.state = {
            addingPossessor: false,
            newPossessor: null,
            file: null
        };
        this.loadPeople = _.debounce(this.loadPeople, 250);
    }

    loadEmittedCertificates = (tableState) => {
        this.tableState = tableState;
        if (tableState.filters.name) tableState.filters['person.name'] = tableState.filters.name;
        const filters = {...tableState.filters, 'certificate': this.props.certificate.id};
        this.context.api.emittedCertificates.get(tableState.page, tableState.pageSize, undefined, filters);
    };

    loadPeople = (name) => {
        return this.context.api.people.getSimple(0, 10, undefined, {orSearch_fullname: name})
            .then((people = []) => people.map((person) => ({
                value: person.id,
                label: personFullName(person)
            })))
    };

    onFormChange = ({target}) => this.setState({...this.state, [target.name]: target.value});

    addPossessor = () => this.setState({'addingPossessor': true});

    savePossessor = () => {
        if (!this.state.newPossessor) return this.context.notifier.error('Debes introducir una persona');
        //if (!this.state.file) return this.context.notifier.error('Falta archivo');
        const possessor = {"person": this.state.newPossessor.value, "certificate": this.props.certificate.id};
        this.context.api.emittedCertificates.create(possessor, undefined, this.state.file).then(this.finish);
    };

    finish = () => this.setState({'addingPossessor': false});

    onHide = () => this.setState({'addingPossessor': false});

    deletePossessor = (e) => {
        this.context.api.emittedCertificates.delete(this.props.emittedCertificates[e.currentTarget.dataset.index].id);
    };

    componentDidMount = () => this.context.api.clearProperty('emittedCertificates');

    onFileChange = ({target}) => {
        if (target.files.length) this.setState({file: target.files[0]});
        else this.setState({file: undefined});
    };

    tableDefinitionPossessors =
        [
            {
                name: '',
                accessor: (data, index) =>
                    <span>
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.deletePossessor}><i
                            className='ti-trash'/></button>
                    </span>
            }, {
            name: 'Nombre',
            id: 'name',
            filterable: true,
            accessor: (possessor) => {
                return personFullName(possessor.person)
            },
        }, {
            name: 'Constancia',
            id: 'emittedCertificate',
            filterable: true,
            accessor: (emittedCertificate) => {
                return <a
                    href={emittedCertificate.file && this.context.api.appFiles.getDownloadUrl(emittedCertificate.file.id)}
                    rel='noopener'>{emittedCertificate.file && emittedCertificate.file.originalName}</a>
            },
        }
        ];

    render() {
        return (
            <div>
                <Modal
                    show={true}
                    dialogClassName="custom-dialog"
                    onHide={this.props.onHide}
                    className='CertificateDetailModal'>
                    <Modal.Header closeButton>
                        <Modal.Title>Detalle de constancia</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className='tabla'>
                                <div className='fila'>
                                    <div className='columna lbl'>Nombre:</div>
                                    <div className='columna'>{this.props.certificate.name}</div>
                                </div>
                                {this.props.certificate.congress &&
                                <div className='fila'>
                                    <div className='columna lbl'>Congreso:</div>
                                    <div className='columna'>{this.props.certificate.congress.name}</div>
                                </div>}

                                {this.props.certificate.event &&
                                <div className='fila'>
                                    <div className='columna lbl'>Evento:</div>
                                    <div className='columna'>{this.props.certificate.event.name}</div>
                                </div>
                                }
                                <div className='fila'>
                                    <div className='columna lbl'>Poseedores:</div>
                                    <div className='columna asistencias'>
                                        <div className='buttonContainer'>
                                            <button
                                                className='btn btn-success btn-fill btn-magnify pull-right'
                                                onClick={this.addPossessor}>
                                                <span className='btn-label'><i className='ti-plus'/></span>
                                            </button>
                                            <a href={this.context.api.emittedCertificates.exportUrl(this.tableState ? {
                                                ...this.tableState.filters,
                                                certificate: this.props.certificate.id
                                            } : null, 'xlsx')}>
                                                <button
                                                    className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                                    <span className='btn-label'>Descargar excel</span>
                                                </button>
                                            </a>
                                            <a href={this.context.api.emittedCertificates.exportUrl(this.tableState ? {
                                                ...this.tableState.filters,
                                                certificate: this.props.certificate.id
                                            } : null, 'pdf')}>
                                                <button
                                                    className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                                    <span className='btn-label'>Descargar PDF</span>
                                                </button>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <Table
                                paginated
                                defaultPageSize={50}
                                rowIdAccessor={'id'}
                                totalItems={this.props.emittedCertificatesMeta.totalItems}
                                loadData={this.loadEmittedCertificates}
                                columns={this.tableDefinitionPossessors}
                                data={this.props.emittedCertificates}/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='danger' onClick={this.props.onHide}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
                {this.state.addingPossessor ?
                    <Modal
                        size='sm'
                        show={true}
                        onHide={this.onHide}>
                        <Modal.Header closeButton>
                            <Modal.Title>Añadir poseedor</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormGroup>
                                <ControlLabel>Poseedor:</ControlLabel>
                                <SelectAsync
                                    cacheOptions
                                    placeholder='Nombre del nuevo poseedor'
                                    noOptionsMessage={() => "Sin coincidencias"}
                                    loadOptions={this.loadPeople}
                                    onChange={(value) => this.onFormChange({target: {name: "newPossessor", value}})}/>
                            </FormGroup>
                            {this.props.certificate && !this.props.certificate.templateFile ?
                            <FormGroup>
                                <ControlLabel>Agregar archivo:</ControlLabel>
                                <FormControl type='file' onChange={this.onFileChange}/>
                            </FormGroup>:
                                <p>La constancia se generará automáticamente</p>
                            }
                            <hr/>
                            <Button
                                bsStyle='danger'
                                onClick={this.onHide}>Cancelar</Button>
                            <Button
                                onClick={this.savePossessor}
                                bsStyle='success'
                                className='pull-right'>Añadir</Button>
                        </Modal.Body>
                    </Modal> : null}
            </div>
        );
    }
}

const mapStateToProps = ({api: {emittedCertificates = [], emittedCertificatesMeta = {}, people = []},}) => ({
    emittedCertificates,
    emittedCertificatesMeta,
    people
});

export default connect(mapStateToProps)(CertificateDetailModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Certificates/components/CertificateDetailModal/index.jsx